import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AsignCUG = ({ show, onClose, selectedid, data }) => {

  const baseURL = process.env.REACT_APP_API_BASE_URL;

  const [jobroleopt, setjobroleopt] = useState([]);
  useEffect(() => {
      const fetchLeadSource = async () => {
          try {
            const response = await axios.get(`${baseURL}/dropdown/get_job_role`);
            const formattedsource = response.data.data.map(item => ({
              value: item.sno,
              label: item.jobrole_name,
            }));
            setjobroleopt(formattedsource);
          } catch (error) {
              console.log('Error fetching data:', error);
          }
      };

      fetchLeadSource();
  }, []);
  
  const [staffopt, setstaffopt] = useState([]);

  const [staffdetails, setStaffDetails] = useState([
    {
      id: Date.now(),
      jobRole: null,
      staff: null,
      showMobile: false,
      mobileNo: '',
      showEmail: false,
      emailId: '',
    },
  ]);

  const [com_staff_opt, setComStaffOPT] = useState([]);
  const [com_staff, setComStaff] = useState(null);
  const [com_staff_mob, setcomstaffmob] = useState(null);

  useEffect(() => {
      const fetchLeadSource = async () => {
          try {
            const response = await axios.get(`${baseURL}/dropdown/get_branch_staffs`, {params: {branch_id: selectedid}});
            const formattedsource = response.data.data.map(item => ({
              value: item.sno,
              label: item.employee_name,
            }));
            setComStaffOPT(formattedsource);
          } catch (error) {
              console.log('Error fetching data:', error);
          }
      };

      fetchLeadSource();
  }, []);


  useEffect(() => {
    if(data){
      setComStaff(com_staff_opt.find(stf => stf.value === data.communication_staff));
      setcomstaffmob(data.communication_mobileno);
    }
    if (data?.communication_details) {
      try {

        const parsed = JSON.parse(data.communication_details);


        const mapped = parsed.map((item) => ({
          id: item.id || Date.now(),
          jobRole: item.jobRole || null,
          staff: item.staff || null,
          showMobile: item.showMobile || false,
          mobileNo: item.mobileNo || '',
          showEmail: item.showEmail || false,
          emailId: item.emailId || '',
        }));

        setStaffDetails(mapped);
      } catch (error) {
        console.error('Failed to parse communication_details:', error);
      }
    }
  }, [data, com_staff_opt, jobroleopt]);


  const [errors, setErrors] = useState({});
  const validate = () => {
      const newErrors = {};
      const num = /^[6-9]\d{9}$/;

      if (!com_staff_mob) {
          newErrors.mob = "This Field is Required.";
      } else if (com_staff_mob.length < 10) {
        newErrors.mob = 'Enter a Valid Number.';
      }

      if (!com_staff) {
          newErrors.comstaff = "This Field is Required.";
      }

      staffdetails.forEach((config) => {
        const errors = {}; // collect errors per field for this config

        if (!config.jobRole) {
          errors.jobRole = 'This Field is Required.';
        }

        if (!config.staff) {
          errors.staff = 'This Field is Required.';
        }

        if (config.showMobile) {
          if (!config.mobileNo) {
            errors.mobileNo = 'This Field is Required.';
          } else {
            if (config.mobileNo.length < 10) {
              errors.mobileNo = 'Enter a Valid Number.';
            } else if (!num.test(config.mobileNo)) {
              errors.mobileNo = 'Not a Valid Number.';
            }
          }
        }

        if (config.showEmail) {
          if (!config.emailId) {
            errors.emailId = 'This Field is Required.';
          }
          if(config.emailId && (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(config.emailId))){
            newErrors.emailId = "Invalid Email.";
          }
        }

        if (Object.keys(errors).length > 0) {
          newErrors[config.id] = errors;
        }
      });

      return newErrors;
  };

  // Add new IP configuration
  const handleAddConfig = () => {
    setStaffDetails([
      ...staffdetails,
      {
        id: Date.now(),
        jobRole: null,
        staff: null,
        showMobile: false,
        mobileNo: '',
        showEmail: false,
        emailId: '',
      },
    ]);
  };

  // Delete an IP configuration
  const handleDeleteConfig = (id) => {
    setStaffDetails(staffdetails.filter((config) => config.id !== id));
  };

  const handleCheckboxChange = (id, field) => (e) => {
    const updated = staffdetails.map((item) => {
      if (item.id === id) {
        return { ...item, [field]: e.target.checked };
      }
      return item;
    });
    setStaffDetails(updated);
  };

  const handleInputChange = (id, field) => (e) => {
    const updated = staffdetails.map((item) => {
      if (item.id === id) {
        return { ...item, [field]: e.target.value };
      }
      return item;
    });
    setStaffDetails(updated);
  };

  const [selectedstaff, setselectedstaff] = useState([]);

  const handleSelectChange = (id, field) => (selectedOption) => {
    const updated = staffdetails.map((item) => {
      if (item.id === id) {
        return { ...item, [field]: selectedOption };
      }
      return item;
    });
    setStaffDetails(updated);

    if(field === 'jobRole'){
      try {
        axios.get(`${baseURL}/dropdown/getstaff_by_role/${selectedOption.value}`, {params: {branch_id: selectedid}})
        .then((response) => {
          const formattedsource = response.data.data .filter(item => !selectedstaff.includes(item.sno))
          .map(item => ({
            value: item.sno,
            label: item.name,
          }));
          setstaffopt(formattedsource);
        })
        .catch((err) => {
              console.log("Failed to fetch ", err);
        });
      } catch (error) {
          console.log('Error fetching data:', error);
      }
    }  else if (field === 'staff') {
      // Update selectedstaff when a staff member is selected
      // Extract sno value from selectedOption.value
      const newSelectedStaff = [...selectedstaff];

      // Find existing staff for this id (to remove previous selection if any)
      const prevStaff = staffdetails.find(item => item.id === id)?.staff;

      if (prevStaff && prevStaff.value !== selectedOption.value) {
        // Remove old staff sno from selectedstaff
        const index = newSelectedStaff.indexOf(prevStaff.value);
        if (index > -1) newSelectedStaff.splice(index, 1);
      }

      // Add new selected staff sno if not already present
      if (!newSelectedStaff.includes(selectedOption.value)) {
        newSelectedStaff.push(selectedOption.value);
      }

      setselectedstaff(newSelectedStaff);
    }
  };

  const handleSubmit = (event) => {
      event.preventDefault();

      const validationErrors = validate();
      console.log(validationErrors);
      if (Object.keys(validationErrors).length > 0) {
          setErrors(validationErrors);
          return;
      }

      const postData = { 
        communication_staff: com_staff.value,
        communication_mobileno: com_staff_mob,
        communication_details: JSON.stringify(staffdetails)
      };
      axios.post(`${baseURL}/dropdown/store_cug/${selectedid}`, postData)
          .then(response => {
              onClose();
              // refresh();
              toast.success("CUG Created Successfully!");
          }).catch(error => {
              onClose();
              console.log(error);
              toast.error("CUG Creation Failed");
          });
  };

  return (
    <Modal show={show} size="xl">
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Communication</h3>
          <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>

        <div className="modal-body">
          <div className="row">
            <div className="col-lg-9 mb-3">
                <label className="text-black font-w500 fs-7">Communication Staff<span className="required">*</span></label>
                <Select placeholder={'Select Communication Staff'}
                  options={com_staff_opt}
                  value={com_staff}
                  onChange={(e) => setComStaff(e)}
                />
                {errors.comstaff && <div className="text-danger fs-8 mt-1">{errors.comstaff}</div>}
            </div>

            <div className="col-lg-3 mb-2">
              <label className="text-black font-w500 fs-7">Mobile No<span className="required">*</span></label>
              <input type="text" className="form-control" placeholder="Enter Mobile no" 
                maxLength={10}
                value={com_staff_mob}
                onChange={(e) => {
                    const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                    setcomstaffmob(onlyNums);
                }}
              />
              {errors.mob && <div className="text-danger fs-8 mt-1">{errors.mob}</div>}
            </div>
           
            <div className="col-lg-12 mb-3">
              <div className="mb-0">
                {staffdetails.map(config => (
                  <div key={config.id} data-repeater-item>
                    <div className="row">
                      <div className="col-lg-3 mb-3">
                          <label className="text-black font-w500 fs-7">Job Role<span className="required">*</span></label>
                          <Select
                            placeholder="Select Job Role"
                            options={jobroleopt}
                            value={config.jobRole}
                            onChange={handleSelectChange(config.id, 'jobRole')}
                          />
                          {errors[config.id]?.jobRole && (<div className="text-danger fs-8 mt-1">{errors[config.id].jobRole}</div>)}
                      </div>

                      <div className="col-lg-3 mb-3">
                          <label className="text-black font-w500 fs-7">Staff<span className="required">*</span></label>
                          <Select
                            placeholder="Select Staff"
                            options={staffopt}
                            value={config.staff}
                            onChange={handleSelectChange(config.id, 'staff')}
                          />
                          {errors[config.id]?.staff && (<div className="text-danger fs-8 mt-1">{errors[config.id].staff}</div>)}
                      </div>

                      <div class="col-lg-2 mb-3">
                          <div class="mb-1">
                              <input
                                type="checkbox"
                                className="form-check-input me-2 mt-0"
                                checked={config.showMobile}
                                onChange={handleCheckboxChange(config.id, 'showMobile')}
                              />
                              <label class="text-black font-w500 fs-7">Mobile No {config.showMobile && (<span class="text-danger" style={{ display: 'inline'}} >*</span>)}</label>
                          </div>
                          {config.showMobile && (
                            <>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Mobile No"
                                maxLength={10}
                                value={config.mobileNo}
                                onChange={handleInputChange(config.id, 'mobileNo')}
                              />
                              {errors[config.id]?.mobileNo && (<div className="text-danger fs-8 mt-1">{errors[config.id].mobileNo}</div>)}
                            </>
                          )}
                      </div>

                      <div class="col-lg-3 mb-3">
                          <div class="mb-1">
                              <input
                                type="checkbox"
                                className="form-check-input me-2 mt-0"
                                checked={config.showEmail}
                                onChange={handleCheckboxChange(config.id, 'showEmail')}
                              />
                              <label class="text-black font-w500 fs-7">Email ID{config.showEmail && (<span class="text-danger" style={{ display: 'inline'}} >*</span>)}</label>
                          </div>
                          {config.showEmail && (
                            <>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Email ID"
                                value={config.emailId}
                                onChange={handleInputChange(config.id, 'emailId')}
                              />
                              {errors[config.id]?.emailId && (<div className="text-danger fs-8 mt-1">{errors[config.id].emailId}</div>)}
                            </>
                          )}
                      </div>

                      <div className="col-lg-1 mb-1 px-1 py-1">
                        {staffdetails.length > 1 && (
                          <button
                            className="btn btn-danger mt-4 px-2 py-2"
                            onClick={() => handleDeleteConfig(config.id)}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Delete"
                          >
                            <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mb-1 mt-2">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={handleAddConfig}
                >
                  <span><i className="fa-solid fa-plus fs-6"></i></span>
                  {/* <span className='ms-2 fs-7'>Add Address</span> */}
                </button>
              </div>
            </div>
            
          </div>
          <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
            <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Assign <i className="fas fa-angle-double-right ms-2"></i></Link>
          </div>
        </div>

      </div>
    </Modal>
  );
};

export default AsignCUG;
